/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EntityType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Claim from './Claim/index'
import Invoice from './Invoice/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function EntityType({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Content/Receivables/Content/FilterBy/EntityType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let entityTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'entity_type',
path: 'id',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: entityTypeIdValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Invoice'}>
<Invoice
  viewPath={`${viewPath}/Invoice`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Claim'}>
<Claim
  viewPath={`${viewPath}/Claim`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}